import Divider from "material-ui/Divider";
import React, { Component } from "react";
import moment from 'moment' 
const empsApiData = [
    {
        dp: 'https://static.thenounproject.com/png/593182-200.png',
        title: 'xavior has created an new nft',
        addedon: 1610206015019

    },
    {
        dp: 'https://static.thenounproject.com/png/593182-200.png',
        title: 'new user has has signed up',
        addedon: 1610378858273


    },
];
class ListComponent extends Component {


    constructor(props) {
        super(props);
        const newEmps = empsApiData.map((emp) => ({
            "dp": emp.dp,
            "title": emp.title,
            "addedon": moment([2021, 0, 29]).fromNow()            
        }));
        
        this.state = {
            emps: newEmps
        }
    }
    render() {
        return (
            <div className="App">
                <div className="pl-5">
                    {this.state.emps.map((item, index) => (                        
                        <li className="list pt-15"><img className="w-30 h-30"  src={item.dp}/>
                            <span className="p-12">{item.title}  </span>
                            <span>{item.addedon}  </span>
                            <Divider className="m-9" />
                        </li>
                       
                    ))}
                </div>
            </div>
        );
    }
}


export default ListComponent;